/* CaMode | Two-row available-size preview in product cards.
   Product availability and order remain untouched. */
(function () {
  'use strict';
  if (window.__cmCardSizesTwoRows) return;
  window.__cmCardSizesTwoRows = true;

  var selector = '.card-variant-sizes';
  var maxVisible = 8;
  var hiddenClass = 'cm-card-size-hidden';
  var observed = new WeakSet();
  var widths = new WeakMap();
  var queued = false;

  function getPills(container) {
    return Array.prototype.filter.call(container.children, function (node) {
      return node.classList.contains('size-pill');
    });
  }

  function countRows(elements) {
    var lastY = null;
    var rows = 0;
    elements.forEach(function (element) {
      if (element.classList.contains(hiddenClass)) return;
      var rect = element.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return;
      if (lastY === null || Math.abs(rect.top - lastY) > 3) {
        rows += 1;
        lastY = rect.top;
      }
    });
    return rows;
  }

  function getToggle(container) {
    var toggle = container.querySelector(':scope > .cm-card-sizes-toggle');
    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'cm-card-sizes-toggle ' + hiddenClass;
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        container.dataset.cmSizesExpanded =
          container.dataset.cmSizesExpanded === 'true' ? 'false' : 'true';
        render(container);
      });
      container.appendChild(toggle);
    }
    if (container.lastElementChild !== toggle) container.appendChild(toggle);
    return toggle;
  }

  function render(container) {
    if (!container.isConnected || container.getBoundingClientRect().width < 30) return;
    var pills = getPills(container);
    if (!pills.length) return;

    container.classList.add('cm-card-sizes-compact');
    var toggle = getToggle(container);

    pills.forEach(function (pill) { pill.classList.remove(hiddenClass); });
    toggle.classList.add(hiddenClass);

    if (container.dataset.cmSizesExpanded === 'true') {
      toggle.textContent = '−';
      toggle.setAttribute('aria-label', 'Mostra meno taglie');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.classList.remove(hiddenClass);
      return;
    }

    if (pills.length <= maxVisible && countRows(pills) <= 2) {
      toggle.setAttribute('aria-expanded', 'false');
      return;
    }

    toggle.classList.remove(hiddenClass);
    var visibleCount = Math.min(maxVisible, pills.length - 1);

    while (visibleCount >= 1) {
      pills.forEach(function (pill, index) {
        pill.classList.toggle(hiddenClass, index >= visibleCount);
      });
      toggle.textContent = '+' + (pills.length - visibleCount);
      if (countRows(pills.slice(0, visibleCount).concat(toggle)) <= 2) break;
      visibleCount -= 1;
    }

    toggle.setAttribute('aria-label',
      'Mostra altre ' + (pills.length - visibleCount) + ' taglie');
    toggle.setAttribute('aria-expanded', 'false');
  }

  var resizeObserver = typeof ResizeObserver !== 'undefined'
    ? new ResizeObserver(function (entries) {
        var changed = false;
        entries.forEach(function (entry) {
          var width = entry.contentRect.width;
          var previous = widths.get(entry.target);
          if (previous === undefined || Math.abs(width - previous) >= 1) {
            widths.set(entry.target, width);
            changed = true;
          }
        });
        if (changed) schedule();
      })
    : null;

  function refresh() {
    document.querySelectorAll(selector).forEach(function (container) {
      if (resizeObserver && !observed.has(container)) {
        observed.add(container);
        widths.set(container, container.getBoundingClientRect().width);
        resizeObserver.observe(container);
      }
      render(container);
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      refresh();
    });
  }

  function containsNewSizes(node) {
    if (node.nodeType !== 1) return false;
    if (node.matches && node.matches(selector + ', .size-pill')) return true;
    return !!(node.querySelector && node.querySelector(selector));
  }

  function start() {
    refresh();
    var observer = new MutationObserver(function (records) {
      var needsUpdate = records.some(function (record) {
        if (Array.prototype.some.call(record.addedNodes, containsNewSizes)) return true;
        if (record.target.nodeType === 1 &&
            record.target.matches && record.target.matches(selector)) {
          return Array.prototype.some.call(record.removedNodes, containsNewSizes);
        }
        return false;
      });
      if (needsUpdate) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  }

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();